import { Checkbox, FormControlLabel, FormGroup, Grid } from "@mui/material";
import { addNewAdvRequest } from "api/adv";
import UploadCm from "components/AdvsUploadCm";
import BackButton from "components/shared/BackButton";
import DrawerCM from "components/shared/Drawer";
import LoadingCM from "components/shared/Loading";
import ProgressBarCM from "components/shared/ProgressBar";
import StackCm from "components/shared/StackCm";
import TextFieldCm from "components/shared/TextField";
import {
  ATTR_OPTIONS,
  DEAL_TYPES,
  DOCUMENT_TYPES,
  MAIN_SUB_CATEGORY,
  PLACE_TYPES,
} from "constants/advOptions";
import { categoriesData } from "constants/category";
import Toast from "helper/toast";
import useHttp from "hooks/use-http";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { StyledGlBtn, StyledGlTitle } from "styles/globals";
import { yupResolver } from "@hookform/resolvers/yup";
import titleSchema from "validations/titleRequired";

const INPUTS = [
  {
    id: "title",
    label: "عنوان",
    rows: 2,
  },
  {
    id: "age",
    label: "سن",
    type: "number"
  },
  {
    id: "floor",
    label: "طبقه",
    type: "number"
  },
  {
    id: "meterage",
    label: "متراژ",
    type: "number"
  },
  {
    id: "room_count",
    label: "تعداد اتاق",
    type: "number"
  },
  {
    id: "main_sub_category",
    label: "زیردسته اصلی",
    selectItems: MAIN_SUB_CATEGORY,
    type: "select",
  },
  {
    id: "deal_type",
    label: "نوع قرارداد",
    selectItems: DEAL_TYPES,
    type: "select",
  },
  {
    id: "place_type",
    label: "نوع ملک",
    selectItems: PLACE_TYPES,
    type: "select",
  },
  {
    id: "document_type",
    label: "نوع سند",
    selectItems: DOCUMENT_TYPES,
    type: "select",
  },
  {
    id: "category",
    label: "محله",
    selectItems: categoriesData,
    type: "select",
  },
];

export default function AddNewAdv() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm({resolver: yupResolver(titleSchema)});

  // IMAGE
  const [image1, setImage1] = useState({
    url: null,
    isChanged: false,
  });

  const [image2, setImage2] = useState({
    url: null,
    isChanged: false,
  });

  const [image3, setImage3] = useState({
    url: null,
    isChanged: false,
  });

  const [video, setVideo] = useState({
    url: null,
    isChanged: false,
  });

  const [videoImage, setVideoImage] = useState({
    url: null,
    isChanged: false,
  });

  const [attributes, setAttributes] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const { request, loading, isUploading, setUploadProgress, uploadProgress } =
    useHttp(false);

  const onSubmit = async (data) => {
    data.image_1 = image1.url;
    data.image_2 = image2.url;
    data.image_3 = image3.url;
    data.video = video.url;
    data.img_video = videoImage.url;
    data.attributes = data.attributes.join(",");

    const res = await request({
      url: () =>
        addNewAdvRequest(
          {
            ...data,
          },
          (progress) => setUploadProgress(progress)
        ),
      isFile: true,
    });
    if (res) {
      Toast({ type: "success", title: "افزودن آگهی" });
      navigate(-1);
    }
  };

  return (
    <DrawerCM title="افزودن آگهی">
      <Grid container mt={3}>
        <BackButton />
      </Grid>
      {isUploading ? (
        <ProgressBarCM value={uploadProgress} />
      ) : loading ? (
        <LoadingCM />
      ) : (
        ""
      )}
      <StackCm title="فیلد های آگهی">
        <Grid container>
          {INPUTS.map((input, index) => (
            <Grid
              key={input.id}
              item
              md={index === 0 ? 12 : 4}
              sm={index === 0 ? 12 : 6}
              xs={12}
              p={1.5}
            >
              <TextFieldCm
                {...input}
                register={register}
                errors={errors}
                control={control}
              />
            </Grid>
          ))}

          <Grid item md={4} sm={6} xs={12} p={1.5}>
            <TextFieldCm
              id={"sub_category"}
              type={"select"}
              label={"زیردسته"}
              selectItems={
                watch("category") == 1
                  ? categoriesData[0].subCategories
                  : []
              }
              register={register}
              errors={errors}
              control={control}
            />
          </Grid>

          <StyledGlTitle style={{ marginTop: "40px" }}>
            عکس و ویدئو
          </StyledGlTitle>
          <Grid item md={4} xs={12} p={1.5}>
            <UploadCm
              title={"بارگزاری عکس اول"}
              id={"image_1"}
              state={image1}
              setState={setImage1}
            />
          </Grid>
          <Grid item md={4} xs={12} p={1.5}>
            <UploadCm
              title={"بارگزاری عکس دوم"}
              id={"image_2"}
              state={image2}
              setState={setImage2}
            />
          </Grid>
          <Grid item md={4} xs={12} p={1.5}>
            <UploadCm
              title={"بارگزاری عکس سوم"}
              id={"image_3"}
              state={image3}
              setState={setImage3}
            />
          </Grid>
          <Grid item md={6} xs={12} p={1.5}>
            <UploadCm
              type="video"
              title={"بارگزاری ویدئو"}
              state={video}
              setState={setVideo}
            />
          </Grid>
          <Grid item md={6} xs={12} p={1.5}>
            <UploadCm
              title={"بارگزاری عکس ویدئو"}
              id={"image_video"}
              state={videoImage}
              setState={setVideoImage}
            />
          </Grid>
          <Grid item md={4} sm={6} xs={12} p={1.5}>
            <TextFieldCm
              id="alt_1"
              label="متن جایگزین (alt 1)"
              register={register}
              errors={errors}
              control={control}
            />
          </Grid>
          <Grid item md={4} sm={6} xs={12} p={1.5}>
            <TextFieldCm
              id="alt_2"
              label="متن جایگزین (alt 2)"
              register={register}
              errors={errors}
              control={control}
            />
          </Grid>
          <Grid item md={4} sm={6} xs={12} p={1.5}>
            <TextFieldCm
              id="alt_3"
              label="متن جایگزین (alt 3)"
              register={register}
              errors={errors}
              control={control}
            />
          </Grid>
          <StyledGlTitle style={{ marginTop: "40px" }}>ویژگی ها</StyledGlTitle>
          {ATTR_OPTIONS.map((options, index) => (
            <Grid key={options.id} item md={4} sm={6} xs={12} p={1.5}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      {...register(`attributes[${options.id}]`)}
                      checked={attributes[options.id]}
                      onChange={(e) => {
                        setAttributes((prevStatus, index) => ({
                          ...prevStatus,
                          [options.id]: e.target.checked,
                        }));
                      }}
                    />
                  }
                  label={options.title}
                />
              </FormGroup>
            </Grid>
          ))}
          <StyledGlTitle style={{ marginTop: "40px" }}>سئو</StyledGlTitle>
          <Grid item xs={12} p={1.5}>
            <TextFieldCm
              id="keyword"
              label="کلمات کلیدی"
              register={register}
              errors={errors}
              control={control}
            />
          </Grid>
          <Grid item xs={12} p={1.5}>
            <TextFieldCm
              id="meta_description"
              label="توضیحات"
              register={register}
              errors={errors}
              control={control}
              rows={2}
            />
          </Grid>
          <StyledGlBtn onClick={handleSubmit(onSubmit)} />
        </Grid>
      </StackCm>
    </DrawerCM>
  );
}
